const ALL_VARIABLE_TEXT = "All";
const ALL_VARIABLE_VALUE = "$__all";
const AUTO_VARIABLE_TEXT = "Auto";
const AUTO_VARIABLE_VALUE = "$__auto";
const VARIABLE_REGEX = /\$(\w+)|\[\[(\w+?)(?::(\w+))?\]\]|\${(\w+)(?:\.([^:^\}]+))?(?::([^\}]+))?}/g;
const SEARCH_FILTER_VARIABLE = "__searchFilter";
const SCOPES_VARIABLE_NAME = "__scopes";

export { ALL_VARIABLE_TEXT, ALL_VARIABLE_VALUE, AUTO_VARIABLE_TEXT, AUTO_VARIABLE_VALUE, SCOPES_VARIABLE_NAME, SEARCH_FILTER_VARIABLE, VARIABLE_REGEX };
//# sourceMappingURL=constants.js.map
